module.exports = new __parcel__URL__("train_20_inactive.59f27e92.png").toString();